<template>
    <v-card v-if="value" class="mt-6 shop-product-supplies">
        <v-card-title>
            <v-row>
                <v-col class="subtitle-1 py-0">최소구매수량제한 (사용/미사용)</v-col>
                <v-col md="auto" sm="auto" class="py-0">
                    <v-switch v-model="form.enabled" dense hide-details class="mt-0" @change="emit"></v-switch>
                </v-col>
            </v-row>
        </v-card-title>
        <v-expand-transition>
            <div v-show="form.enabled">
                <v-divider />
                <v-card-text>
                    <v-currency-field v-model="form.value" label="최소구매수량" suffix="개" class="text-align-end-input ma-0" hide-details @change="emit" />
                </v-card-text>
            </div>
        </v-expand-transition>
    </v-card>
</template>

<script>
import { initAmountMinConf } from "@/assets/variables";

export default {
    props: {
        /** @type {import('vue').PropType<import('@/assets/variables').AmountMinConf>} */
        value: { type: Object, default: initAmountMinConf },
    },
    data: () => ({
        form: initAmountMinConf(),
    }),
    methods: {
        sync() {
            this.form = initAmountMinConf(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .text-align-end-input input {
        text-align: end;
    }
}
</style>
